// Copie locale de l'onglet Consignes pour la lecture sans réseau.
// La liste des étudiants est liée à l'agent connecté et effacée à la déconnexion.

const CONSIGNES_KEY = 'vatel-consignes-v1';
const STUDENTS_KEY = 'vatel-students-v1';

function read(key) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
}

function write(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch (error) {
    return false;
  }
}

export function readConsignesCache() {
  const data = read(CONSIGNES_KEY);
  return data && Array.isArray(data.sections) ? data : null;
}

export function writeConsignesCache(data) {
  if (!data || !Array.isArray(data.sections)) return false;
  return write(CONSIGNES_KEY, { sections: data.sections, updated_at: data.updated_at || null, saved_at: new Date().toISOString() });
}

export function readStudentsCache(agentId) {
  const data = read(STUDENTS_KEY);
  if (!data || !agentId || data.agent_id !== agentId || !Array.isArray(data.students)) return null;
  return data;
}

export function writeStudentsCache(agentId, data) {
  if (!agentId || !data || !Array.isArray(data.students)) return false;
  return write(STUDENTS_KEY, {
    agent_id: agentId,
    students: data.students,
    updated_at: data.updated_at || null,
    source_label: data.source_label || null,
    saved_at: new Date().toISOString(),
  });
}

export function clearStudentsCache() {
  try {
    localStorage.removeItem(STUDENTS_KEY);
  } catch (error) {
    /* localStorage indisponible */
  }
}
